/** Public company WhatsApp controls. Only company administrators may change these. */
export interface WhatsAppSettings {
	conversationInactivitySeconds: number;
	humanTimeoutSeconds: number;
	responseGraceSeconds: number;
}
export const DEFAULT_WHATSAPP_SETTINGS: WhatsAppSettings = {
	conversationInactivitySeconds: 86400,
	humanTimeoutSeconds: 43200,
	responseGraceSeconds: 5,
};
export type WhatsAppConversationMode =
	| "ai"
	| "human_temporary"
	| "human_persistent";
export interface WhatsAppConversation {
	id: string;
	companyId: string;
	threadId: string;
	phoneNumberId: string;
	customerWaId: string;
	customerName: string;
	agentId: string | null;
	borrowId: string | null;
	startedAt: string;
	lastMessageAt: string;
	lastMessagePreview: string;
	messageCount: number;
	status: "active" | "closed";
	closedAt?: string;
}
export interface WhatsAppThread {
	mode: WhatsAppConversationMode;
	timeoutOverrideSeconds: number | null;
	lastHumanReplyAt: string | null;
	lastCustomerAt: string | null;
	currentConversationId: string;
	revision: number;
	pendingOutboundId?: string | null;
	processing?: { owner: string; expiresAt: string } | null;
}
export interface WhatsAppConversationMessage {
	id: string;
	direction: "inbound" | "outbound";
	origin: "customer" | "business_app" | "ai";
	text: string;
	messageType: string;
	providerMessageId: string | null;
	providerAt: string;
	sequence: number;
	status: string;
	command?: {
		name: string;
		error?: string;
		ignored?: string;
		mode?: WhatsAppConversationMode;
		effectiveTimeoutSeconds?: number;
		timeoutSource?: "override" | "company";
		pendingResponse?: boolean;
	} | null;
}
